import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  viewChild,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { IconFieldModule } from 'primeng/iconfield';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { debounceTime, distinctUntilChanged } from 'rxjs';

@Component({
  standalone: true,
  selector: 'kon-search',
  template: `
    <p-inputGroup class="card flex flex-wrap justify-content-center gap-3">
      <input
        #seachUnscheduled
        pInputText
        type="text"
        class="w-full"
        placeholder="Hľadať..."
        [formControl]="formControl"
        (keyup.enter)="emitSearch(formControl.value)"
      />
      @if (formControl.value) {
      <p-inputGroupAddon
        pButton
        icon="pi pi-times"
        [outlined]="true"
        severity="secondary"
        (click)="formControl.setValue(null)"
        pTooltip="Zrušiť vyhľadávanie"
      >
      </p-inputGroupAddon>
      }
    </p-inputGroup>
  `,
  imports: [
    InputTextModule,
    InputGroupModule,
    InputGroupAddonModule,
    ButtonModule,
    FormsModule,
    ReactiveFormsModule,
    TooltipModule,
    InputIconModule,
    IconFieldModule,
  ],
})
export class SearchComponent implements OnInit {
  private initialized = false;
  @Output() searchChange = new EventEmitter<string | null>();

  @Input() set text(value: string | null) {
    this.search(value, !this.initialized);
  }

  protected formControl = new FormControl<string | null>(null);

  private searchInput =
    viewChild<ElementRef<HTMLInputElement>>('seachUnscheduled');

  protected emitSearch(search: string | null) {
    this.searchChange.emit(search?.trim());
  }

  focus() {
    this.searchInput()?.nativeElement.focus();
  }

  search(text: string | null, emitEvent = true) {
    if (text?.trim() !== this.formControl.value?.trim()) {
      this.formControl.setValue(text, { emitEvent });
    }
  }

  constructor() {
    this.formControl.valueChanges
      .pipe(
        // ignore whitespace changes
        distinctUntilChanged((previous, current) => {
          return previous?.trim() === current?.trim();
        }),
        debounceTime(300),
        takeUntilDestroyed(),
      )
      .subscribe((search) => this.emitSearch(search));
  }

  ngOnInit(): void {
    this.initialized = true;
  }
}
